import { debounce } from 'debounce'
import { setupFabric } from '@/libraries'
import { useUserStore } from '@/stores'

export default function setup (app) {
  setupApp()
  setupFabric()
  setupEventListeners()
}

function setupApp () {
  
  const initialState = window.__INITIAL_STATE__
  if (initialState.app.isHmtDevice) {
    const wmlScript = document.createElement('script')
    wmlScript.src = '/libs/wearml/wearml_engine-updated.js'
    document.body.appendChild(wmlScript)
    document.body.setAttribute('tabindex', '-1')
    document.body.setAttribute('title', 'hf_no_overlay')
  }  
}

function setupEventListeners () {
  const user = useUserStore()
  window.addEventListener('resize', debounce(() => {
    const { clientWidth: width, clientHeight: height } = document.documentElement
    user.setViewport(width, height)
  }, 500))
}
